/**
 * Chat State Store (Valtio)
 * 
 * このファイルは後方互換性のために維持されています。
 * 新しいコードでは、@/contexts/StoreContext の useChatStore フックを使用してください。
 */

// 後方互換性のため、アダプター層から直接エクスポート
export { chatStore, resetChatStore } from './adapters/globalStoreAdapter';

// ヘルパー関数のエクスポート（後方互換性のため）
export {
  wsErrorStore,
  saveChatStateForPage,
  loadChatStateForPage,
  clearPageCache,
  clearAllPageCaches,
  cleanupChatStore,
  logChatState,
} from './legacy/chatStoreHelpers';

// 型定義のエクスポート（後方互換性のため）
export type { ChatStore, ConversationHistoryItem } from './types';